import styled from "@emotion/styled";

import { ThemeMode } from "../../context/ThemeContext";

export const AppBodyLayoutWrapper = styled.div<{ mode: ThemeMode }>`
  box-sizing: border-box;
  padding: 32px 0 0;
  min-height: calc(100vh - 74px);
  background-color: ${({ mode }) => (mode === "dark" ? "#1F242A" : "#F0F0F0")};
  color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#333333")};
`;
